import React, { FC, useState } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { startEditElement } from "../../actions/elementListAction";
import { startEditForm } from "../../actions/formListAction";
import { startEditSession } from "../../actions/sessionListAction";
import { Element } from "../../models/elementModel";
import { AppState } from "../../reducers/rootReducer";
import { InputTypes } from "../../utils/constants";
import ColProperties from "./common/colProperties";
import ElementStyleProperties from "./common/elementStyleProperties";
import FontStyleProperties from "./common/fontStyleProperties";
import LabelProperties from "./common/labelProperties";
import FormProperties from "./form/formProperties";
import RenderProperties from "./renderProperties";
import RowProperties from "./row/rowProperties";
import "./propertypanel.scss";
import RuleProperties from "./common/ruleProperty/ruleProperties";
import RemarkProperties from "./common/remarkProperties";
import { Accordion, Button, Card, Tab, Tabs } from "react-bootstrap";
import { Tooltip } from "react-tippy";
import UndoRedoButtonComponent from "../util/undoButtonComponent";
import { MdDevices, MdLabel } from "react-icons/md";
import { GiPencilBrush, GiRuleBook } from "react-icons/gi";
import { FaFont, FaComments } from "react-icons/fa";
import { BsFillGearFill } from "react-icons/bs";

const PropertyPanelComponent: FC = () => {
  const dispatch = useDispatch();
  let isPropertySelected: boolean = false;
  let selectedItem: any;
  const selectedType = useSelector(
    (state: AppState) => state.session.selectedType
  );
  const rowState = useSelector((state: AppState) => state.rowList);
  const elementState = useSelector((state: AppState) => state.elementList);
  const sessionState = useSelector((state: AppState) => state.session);
  const formState = useSelector((state: AppState) => state.formList);

  const commonElementProperties = () => {
    return (
      <Accordion defaultActiveKey="generalProp" key={"commonElementProperties"}>
        <Card className="theam-component">
          <Accordion.Toggle
            as={Button}
            variant="outline-dark"
            className="theam-font"
            eventKey="generalProp"
          >
            General Properties
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="generalProp">
            <Card.Body className="theam-card pl-0">
              <RenderProperties element={selectedItem} />
              {selectedItem.properties.labelPosition != undefined &&
                !(
                  selectedItem.type === "btn" ||
                  selectedItem.type === "heading" ||
                  selectedItem.type === "lbl" ||
                  selectedItem.type === "tab" ||
                  selectedItem.type === "navbar" ||
                  selectedItem.type === "table"
                ) && <LabelProperties element={selectedItem} />}
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        <Card className="theam-component">
          <Accordion.Toggle
            as={Button}
            variant="outline-dark"
            className="theam-font"
            eventKey="styleProp"
          >
            Style Properties
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="styleProp">
            <Card.Body className="theam-card pl-0 pt-0">
              <ElementStyleProperties element={selectedItem} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        {!(
          selectedItem.type === "map" ||
          selectedItem.type === "video" ||
          selectedItem.type === "img"
        ) && (
          <Card className="theam-component">
            <Accordion.Toggle
              as={Button}
              variant="outline-dark"
              className="theam-font"
              eventKey="fontProp"
            >
              Font Properties
            </Accordion.Toggle>

            <Accordion.Collapse eventKey="fontProp">
              <Card.Body className="theam-card pl-0">
                <FontStyleProperties element={selectedItem} />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        )}
      </Accordion>
    );
  };

  const renderElementProperties = () => {
    let isElement = false;
    const selectedElement = elementState.present.filter((element) => {
      if (element.id === sessionState.selectedElementId) {
        return element;
      }
    });

    if (selectedElement.length > 0) {
      isPropertySelected = true;
      // selectedItem = { ...selectedElement[0] };
      selectedItem = selectedElement[0];

      return (
        <>
          <div className="property-container">
            <Tabs className="myClass" defaultActiveKey="properties" style={{border:0}}>
              <Tab eventKey="properties" tabClassName="btn-dark theme-tab-btn theam-font-tab mr-2" title={"Properties"}>
                {commonElementProperties()}
              </Tab>
              <Tab eventKey="remarks" tabClassName="btn-dark theme-tab-btn theam-font-tab mr-2" title={"Remarks"}>
                <RemarkProperties element={selectedItem} />
              </Tab>
              {(selectedItem.type === "btn" ||
                selectedItem.type === "rdioBtn" ||
                selectedItem.type === "chkBox" ||
                selectedItem.type === "dropdown" ||
                selectedItem.type === "lbl" || 
                selectedItem.type === "img" ||
                selectedItem.type === "navbar") && (
                <Tab eventKey="interactions" tabClassName="btn-dark theme-tab-btn theam-font-tab" title={"Interactions"}>
                  <RuleProperties element={selectedItem} />
                </Tab>
              )}
            </Tabs>
            {/* <Tabs defaultActiveKey="home" id="uncontrolled-tab-example">
            <Tab eventKey="home"  title={
            <Tooltip title="General Properties">
              <BsFillGearFill size={15}/>
            </Tooltip>
            }>
              <RenderProperties element={selectedItem} />
            </Tab>
            {(selectedItem.properties.labelPosition != undefined && !(selectedItem.type === 'btn' || selectedItem.type === 'heading' || selectedItem.type === 'lbl' || selectedItem.type === 'tab' || selectedItem.type === 'navbar' || selectedItem.type === 'table')) && (
              <Tab eventKey="profile" title={
                <Tooltip title="Lable Properties">
                  <MdLabel size={15}/>
                </Tooltip>
              }>
                <LabelProperties element={selectedItem} />
              </Tab>
            )}
            <Tab eventKey="contact" title={
                <Tooltip title="Style Properties">
                  <GiPencilBrush size={15}/>
                </Tooltip>
              }>
              <ElementStyleProperties element={selectedItem} />
            </Tab>
            {!(selectedItem.type === 'map' || selectedItem.type === 'video' || selectedItem.type === 'img') && (
              <Tab eventKey="font" title={
                  <Tooltip title="Font Properties">
                    <FaFont size={15}/>
                  </Tooltip>
                }>
                <FontStyleProperties element={selectedItem} />
              </Tab>
            )}
            {(selectedItem.type === 'btn' || selectedItem.type === 'rdioBtn' || selectedItem.type === 'chkBox' || selectedItem.type === 'dropdown' || selectedItem.type === 'lbl') && (
            <Tab eventKey="rule" title={
              <Tooltip title="Rule Properties">
                <GiRuleBook size={15}/>
              </Tooltip>
            }>
              <RuleProperties element={selectedItem} />
            </Tab>
          )}
            <Tab eventKey="remark" title={
              <Tooltip title="Remark Properties">
                <FaComments size={15}/>
              </Tooltip>
            }>
              <RemarkProperties element={selectedItem} />
            </Tab>
          </Tabs> */}
          </div>
        </>
      );
    } else {
      isPropertySelected = false;
      return null;
    }
  };

  const renderRowProperties = () => {
    const selectedRow = rowState.filter((row) => {
      if (row.id === sessionState.selectedRowId) {
        return row;
      }
    });

    if (selectedRow.length > 0) {
      isPropertySelected = true;
      // selectedItem = { ...selectedElement[0] };
      selectedItem = selectedRow[0];

      return <RowProperties row={selectedItem} />;
    } else {
      isPropertySelected = false;
      return null;
    }
  };

  const renderFormProperties = () => {
    const selectedForm = formState.filter((form) => {
      if (form.id === sessionState.selectedFormId) {
        return form;
      }
    });

    if (selectedForm.length > 0) {
      isPropertySelected = true;
      selectedItem = selectedForm[0];
      return <FormProperties form={selectedItem} />;
    } else {
      isPropertySelected = false;
      return null;
    }
  };

  const previewForm = () => {
    window.open(
      `preview/preview-render/${sessionState.selectedFormId}`,
      "_blank"
    );
  };

  return (
    <div className="container-fluid theam-font">
      <div className="row d-flex justify-content-center">
        <div className="col-12 hight-56">
          <div className="m-2 p-2">
            <span>PROPERTY PANEL</span>
          </div>

          {/* <UndoRedoButtonComponent type={"UNDO"} />
          <UndoRedoButtonComponent type={"REDO"} />
          
          <Tooltip title="Preview">
            <Button
              variant="dark"
              className="theam-btn"
              size="lg"
              disabled={
                sessionState.selectedFormId === "" ||
                sessionState.selectedFormId === null
              }
              onClick={() => {
                previewForm();
              }}
            >
              <MdDevices size={25} />
            </Button>
          </Tooltip> */}
        </div>
      </div>
      {/* <div className="row panel-header theam-dark-black">
        <div className="col-12 mt-2 mb-2 p-2">
          <span className="theam-font">PROPERTY PANEL</span>
        </div>
      </div> */}
      <div className="row pt-3 property-panel theam-dark-black">
        {selectedType === "Element" && (
          <div className="col-sm-12 padding-0">{renderElementProperties()}</div>
        )}
        {selectedType === "Row" && (
          <div className="col-sm-12 padding-0">{renderRowProperties()}</div>
        )}
        {selectedType === "Form" && (
          <div className="col-sm-12 padding-0">{renderFormProperties()}</div>
        )}
      </div>
    </div>
  );
};

export default PropertyPanelComponent;
